export default function daysLeft(user) {
  let balance = user.accountBalance;
  let daysLeftCount = 0;
  const currTariffPrice = user.tariff.pricePerDay;

  if (!user.tariff.pricePerDay) {
    return null;
  }

  user.tariffInfo.forEach(discount => {
    if (!discount.days || typeof discount.price !== 'number') {
      return;
    } // discount is invalid

    const discountSum = discount.days * discount.price;
    if (discountSum <= balance) {
      balance -= discountSum;
      daysLeftCount += discount.days;
      return;
    }

    daysLeftCount = Math.floor(balance / discount.price);
    balance = 0;
  });

  daysLeftCount += Math.floor(balance / currTariffPrice);

  return daysLeftCount;
}
